import React from "react";
import { useTranslation } from "react-i18next";
import { CheckCircle, FileSpreadsheet, Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import { DialogFooter } from "../ui/dialog";

const allRequiredMapped = (detectionResult, columnMapping) =>
  detectionResult?.available_fields
    .filter(f => f.required)
    .every(field => Object.values(columnMapping).includes(field.field));

const ImportFooter = ({
  step, setStep, handleClose,
  handleValidateWithMapping, handleImport,
  isValidating, isImporting,
  detectionResult, columnMapping, validationResult,
}) => {
  const { t } = useTranslation();

  return (
  <DialogFooter className="flex justify-between">
    <div>
      {step === "mapping" && (
        <Button variant="outline" onClick={() => setStep("upload")}>{t("common.back")}</Button>
      )}
      {step === "preview" && (
        <Button variant="outline" onClick={() => setStep("mapping")}>{t("common.back")}</Button>
      )}
    </div>
    <div className="flex space-x-2">
      <Button variant="outline" onClick={handleClose}>
        {step === "result" ? t("common.close") : t("common.cancel")}
      </Button>
      {step === "mapping" && (
        <Button
          onClick={handleValidateWithMapping}
          disabled={isValidating || !allRequiredMapped(detectionResult, columnMapping)}
          className="gap-2"
        >
          {isValidating ? (
            <><Loader2 className="h-4 w-4 animate-spin" />{t("importEmployees.footer.validating")}</>
          ) : (
            <><CheckCircle className="h-4 w-4" />{t("importEmployees.footer.validateMapping")}</>
          )}
        </Button>
      )}
      {step === "preview" && validationResult?.can_import && (
        <Button onClick={handleImport} disabled={isImporting} className="gap-2">
          {isImporting ? (
            <><Loader2 className="h-4 w-4 animate-spin" />{t("importEmployees.footer.importing")}</>
          ) : (
            <><FileSpreadsheet className="h-4 w-4" />{t("importEmployees.footer.importEmployees", { count: validationResult.valid_lines })}</>
          )}
        </Button>
      )}
    </div>
  </DialogFooter>
  );
};

export default ImportFooter;
